import React, { useEffect, useState } from "react";
import { Button, Table, Form, Row, Col, FloatingLabel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import AddAsha from "../AddAsha";
import EditAsha from "../EditAsha";
import { Loading, AppPagination } from "../../components/Index";
import { AshaServices } from "../../../services/AshaService";
import { PHCServices } from "../../../services/Phcs";
import { AshaBlockServices } from "../../../services/AshaBlocks";

function TalukAshaView() {
  const user = JSON.parse(localStorage.getItem("user"));
  const itemsPerPage = 10;

  const [allAshaList, setAllAshaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [addModalShow, setAddModalShow] = useState(false);

  const [selectedPhc, setSelectedPhc] = useState("");
  const [selectedAshaBlock, setSelectedAshaBlock] = useState("");

  const [phcs, setPHCs] = useState([]);
  const [ablocks, setAblocks] = useState([]);
  const [allAshaBlocks, setAllAshaBlocks] = useState([]);
  const [pagination, setPagination] = useState({ cur: 1 });

  useEffect(() => {
    getAsha();
    getPhcs(user?.talukDetails?.id);
    getAllAshaBlocks(user?.talukDetails?.id);
  }, []);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, cur: 1 }));
  }, [searchTerm, selectedPhc, selectedAshaBlock]);

  useEffect(() => {
    if (selectedPhc && selectedAshaBlock) {
      getAsha();
    } else {
      setAllAshaList([]);
    }
  }, [selectedPhc, selectedAshaBlock]);

  const getPhcs = async (talukId) => {
    try {
      const res = await PHCServices.gePhcsByTalukId(talukId);
      if (Array.isArray(res)) {
        setPHCs(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setPHCs(values);
        } else {
          setPHCs([]);
        }
      } else {
        setPHCs([]);
      }
    } catch (error) {
      console.error("Failed to load PHCs", error);
      setPHCs([]);
    }
  };

  const getAllAshaBlocks = async (talukId) => {
    try {
      const res = await AshaBlockServices.getAshaBlockByTalukId(talukId);
      if (Array.isArray(res)) {
        setAllAshaBlocks(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setAllAshaBlocks(values);
        } else {
          setAllAshaBlocks([]);
        }
      } else {
        setAllAshaBlocks([]);
      }
    } catch (error) {
      console.error("Failed to load AshaBlocks", error);
      setAllAshaBlocks([]);
    }
  };

  const getAsha = async () => {
    setLoading(true);
    try {
      const res = await AshaServices.getAshaByTalukId(user?.talukDetails?.id);
  
      if (Array.isArray(res)) {
        setAllAshaList(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setAllAshaList(values);
        } else {
          setAllAshaList([]);
        }
      } else {
        setAllAshaList([]);
      }
  
    } catch (error) {
      console.error("Failed to fetch Asha", error);
      setAllAshaList([]);
    }
    setLoading(false);
  };
  

  const filterAshaBlocksByPhc = (phcId) => {
    if (allAshaBlocks.length > 0 && phcId) {
      const filtered = allAshaBlocks.filter(
        (block) => String(block.phcId) === String(phcId)
      );
      setAblocks(filtered);
    } else {
      setAblocks([]);
    }
  };

  const deleteAsha = async (id) => {
    if (window.confirm("Do you want to delete?")) {
      setLoading(true);
      try {
        const res = await AshaServices.deleteAsha(id);
        if (res?.status === 200) {
          alert(res.message);
          getAsha();
        } else {
          alert("Error while deleting");
        }
      } catch (error) {
        alert(error.message);
      }
      setLoading(false);
    }
  };

 const filteredAsha = allAshaList.filter((i) => {
  const matchesSearch = String(i.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(i.preDefinedAshaId || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(i.mobileNo || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(i.ashaBlockDetails?.phcDetails?.phc || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(i.ashaBlockDetails?.ashaBlock || "").toLowerCase().includes(searchTerm.toLowerCase());

  const matchesPhc = selectedPhc ? i.ashaBlockDetails?.phcDetails?.id?.toString() === selectedPhc : true;
  const matchesBlock = selectedAshaBlock ? i.ashaBlockDetails?.id?.toString() === selectedAshaBlock : true;

  return matchesSearch && matchesPhc && matchesBlock;
});



  const startIndex = (pagination.cur - 1) * itemsPerPage;
  const paginatedAsha = filteredAsha.slice(startIndex, startIndex + itemsPerPage);
  const maxPage = Math.ceil(filteredAsha.length / itemsPerPage);

  return (
    <>
      <Row className="mb-3">
        <Col>
          <FloatingLabel controlId="phc" label="PHC" className="mt-3">
            <Form.Select
              value={selectedPhc}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedPhc(value);
                setSelectedAshaBlock("");
                filterAshaBlocksByPhc(value);
              }}
            >
              <option value="">Select</option>
              {phcs.map((phc) => (
                <option key={phc.id} value={phc.id}>
                  {phc.phc}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>

        <Col>
          <FloatingLabel controlId="ashaBlock" label="Asha Block" className="mt-3">
            <Form.Select
              value={selectedAshaBlock}
              onChange={(e) => setSelectedAshaBlock(e.target.value)}
            >
              <option value="">Select</option>
              {ablocks.map((block) => (
                <option key={block.id} value={block.id}>
                  {block.ashaBlock}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>

        <Col>
          <Form.Control
            type="text"
            placeholder="Search by Asha ID or Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="mt-3"
          />
        </Col>

        <Col className="d-flex align-items-center justify-content-end mt-3">
          <Button className="custom-btn" onClick={() => setAddModalShow(true)}>
            Add Asha
          </Button>
        </Col>
      </Row>

      <AddAsha
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        onClose={() => getAsha()}
      />

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sl no</th>
            <th>Asha Name</th>
            <th>Asha ID</th>
            <th>Mob no</th>
            <th>PHC</th>
            <th>Asha Block</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {!loading &&
            paginatedAsha.map((i, index) => (
              <tr key={i.id}>
                <td>{startIndex + index + 1}</td>
                <td>{i.name}</td>
                <td>{i.preDefinedAshaId}</td>
                <td>{i.mobileNo}</td>
                <td>{i.ashaBlockDetails?.phcDetails?.phc || "N/A"}</td>
                <td>{i.ashaBlockDetails?.ashaBlock || "N/A"}</td>
                <td>
                  <EditAsha asha={i} onClose={() => getAsha()} />
                </td>
                <td>
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => deleteAsha(i.id)}
                    size="lg"
                    style={{ cursor: "pointer" }}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      {filteredAsha.length < 1 && !loading && (
        <h3 style={{ color: "#e77225", textAlign: "center" }}>
          No results found
        </h3>
      )}

      {loading && <Loading />}

      <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={pagination.cur}
          maxPage={maxPage}
          changePage={(page) => setPagination((prev) => ({ ...prev, cur: page }))}
        />
      </div>
    </>
  );
}

export default TalukAshaView;
